import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Star } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_ev-aletleri-servis/artifacts/vs6pzaqs_1.png" 
                alt="teknikservisburda.com - Kuşadası Söke Aydın Teknik Servis" 
                className="footer-logo-image"
              />
              <span>teknikservisburda.com</span>
            </div>
            <p className="footer-desc">
              Kuşadası, Söke ve Aydın'da 15 yıldır güvenilir kombi servisi, beyaz eşya tamiri ve klima montaj hizmeti sunuyoruz. Profesyonel ekibimizle aynı gün servis garantisi.
            </p>
            {/* Google Business Badge */}
            <a 
              href="https://share.google/vaRKZbjQoRuwpTORP"
              target="_blank"
              rel="noopener noreferrer"
              className="google-business-badge"
            >
              <div className="gb-rating">
                <Star size={16} fill="#FBBC04" color="#FBBC04" />
                <span className="gb-score">4.8</span>
              </div>
              <span className="gb-text">Google'da Bizi Değerlendirin</span>
            </a>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook"><Facebook size={20} /></a>
              <a href="#" className="social-link" aria-label="Instagram"><Instagram size={20} /></a>
              <a 
                href="https://share.google/vaRKZbjQoRuwpTORP" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link google-link" 
                aria-label="Google Business"
              >
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3>Hızlı Linkler</h3>
            <ul className="footer-links">
              <li><Link to="/">Ana Sayfa</Link></li>
              <li><Link to="/servisler">Servislerimiz</Link></li>
              <li><Link to="/kombi-ariza-kodlari">Kombi Arıza Kodları</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/hakkimizda">Hakkımızda</Link></li>
              <li><Link to="/iletisim">İletişim</Link></li>
              <li><Link to="/talep">Online Talep</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Hizmet Bölgelerimiz</h3>
            <ul className="footer-links">
              <li><Link to="/kusadasi-kombi-servisi">Kuşadası Kombi Servisi</Link></li>
              <li><Link to="/kusadasi-beyaz-esya-servisi">Kuşadası Beyaz Eşya Servisi</Link></li>
              <li><Link to="/kusadasi-klima-servisi">Kuşadası Klima Servisi</Link></li>
              <li><Link to="/soke-kombi-servisi">Söke Kombi Servisi</Link></li>
              <li><Link to="/soke-beyaz-esya-servisi">Söke Beyaz Eşya Servisi</Link></li>
              <li><Link to="/aydin-kombi-servisi">Aydın Kombi Servisi</Link></li>
              <li><Link to="/guzelcamli-kombi-servisi">Güzelçamlı Servisi</Link></li>
              <li><Link to="/davutlar-kombi-servisi">Davutlar Servisi</Link></li>
              <li><Link to="/incirliova-kombi-servisi">İncirliova Servisi</Link></li>
              <li><Link to="/germencik-kombi-servisi">Germencik Servisi</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>İletişim</h3>
            <ul className="footer-contact">
              <li>
                <Phone size={18} />
                <a href="tel:+905518478521">0551 847 8521</a>
              </li>
              <li>
                <Mail size={18} />
                <a href="mailto:teknikservisburda@gmail.com">teknikservisburda@gmail.com</a>
              </li>
              <li>
                <MapPin size={18} />
                <span>Davutlar Mah. Namık Kemal Cad. No:42B<br/>Kuşadası, Aydın</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 teknikservisburda.com - Kuşadası, Söke, Aydın Teknik Servis. Tüm hakları saklıdır.</p>
          <div className="footer-legal-links">
            <Link to="/gizlilik-politikasi">Gizlilik Politikası</Link>
            <span>|</span>
            <Link to="/kullanim-kosullari">Kullanım Koşulları</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;